/*-------------------------------------------------------
||Program           : VoucherDetail.jsx
||Application       : Voucher
||Option            : Voucher Detail
||Developer         : Ashish Kumar
||Date              : 2026-03-24
----------------------------------------------------------*/

import React, { Component } from "react";
import {
  Container,
  InputGroup,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import JoditEditor from "jodit-react";
import { Jodit } from "jodit";
import Moment from "moment";
// import { Link } from "react-router-dom";
import VoucherService from "../../services/VoucherService";
import EmailService from "../../services/EmailService";
import Alerts from "../common/Alerts";
import FileUploadService from "../../services/FileUploadService";

export class VoucherDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      loading: false,
      isSubmit: false,
      isSendSubmit: false,
      isTemplateSaving: false,
      voucher_code_param: this.props.match.params.code,
      voucher_code: "",
      confirmation_code: "",
      guest_first_name: "",
      guest_last_name: "",
      guest_email: "",
      amount: "",
      status: "active",
      custom_message: "",
      custom_email_subject: "",
      expiry_date: "",
      created_at: "",
      used_at: "",
      last_email_sent_at: "",
      is_promo_code: false,
      max_usage_count: "",
      used_count: 0,
      templateOptions: [],
      selectedTemplate: null,
      default_email_subject: "",
      default_email_body: "",
      showVariableModal: false,
      variableTarget: "subject",
      selectedVariable: "",
    };

    this.getVoucherDetail = this.getVoucherDetail.bind(this);
    this.getVoucherTemplates = this.getVoucherTemplates.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.updateVoucher = this.updateVoucher.bind(this);
    this.setCustomMessage = this.setCustomMessage.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);
    this.confirmSendEmail = this.confirmSendEmail.bind(this);
    this.saveTemplate = this.saveTemplate.bind(this);
    this.handleTemplateSelect = this.handleTemplateSelect.bind(this);
    this.resetToDefault = this.resetToDefault.bind(this);
    this.buildDefaultEmailBody = this.buildDefaultEmailBody.bind(this);
    this.buildDefaultEmailSubject = this.buildDefaultEmailSubject.bind(this);
    this.buildPlaceholderMap = this.buildPlaceholderMap.bind(this);
    this.applyPlaceholders = this.applyPlaceholders.bind(this);
    this.toPlaceholderSubject = this.toPlaceholderSubject.bind(this);
    this.toPlaceholderBody = this.toPlaceholderBody.bind(this);
    this.normalizePlaceholders = this.normalizePlaceholders.bind(this);
    this.openVariableModal = this.openVariableModal.bind(this);
    this.closeVariableModal = this.closeVariableModal.bind(this);
    this.insertVariable = this.insertVariable.bind(this);
    this.normalizeTemplateBodyForEditor =
      this.normalizeTemplateBodyForEditor.bind(this);
    this.subjectInputRef = React.createRef();

    this.editorConfig = {
      extraButtons: ["uploadImage", "uploadImageVideo"],
      width: "auto",
      height: "auto",
      minHeight: 400,
      events: {
        afterInit: (instance) => {
          this.jodit = instance;
        },
      },
    };
  }

  componentDidMount() {
    this.getVoucherDetail();
    this.getVoucherTemplates();
    this.uploadImageButton();
    this.uploadVideoButton();
  }

  async getVoucherDetail() {
    if (!this.state.voucher_code_param) {
      return;
    }
    this.setState({ loading: true });
    const res = await VoucherService.getVoucherByCode(
      this.state.voucher_code_param,
    );
    if (global.successStatus.includes(res.status)) {
      const data = res.data ? res.data : {};
      const guestName =
        `${data.guest_first_name || ""} ${data.guest_last_name || ""}`.trim();
      const expiryDate = data.expiry_date
        ? Moment(data.expiry_date).format("YYYY-MM-DD")
        : "";
      const defaultSubject = this.buildDefaultEmailSubject(
        "Voucher",
        guestName,
        data.voucher_code || "",
      );
      const defaultBody = this.buildDefaultEmailBody({
        guest_name: guestName || "Guest",
        voucher_code: data.voucher_code || "",
        amount:
          data.amount !== undefined && data.amount !== null ? data.amount : "",
        status: data.status || "",
        expiry_date: expiryDate,
        instructions:
          "Apply this voucher code at checkout to receive your discount. One-time use only.",
      });
      this.setState({
        voucher_code: data.voucher_code || "",
        confirmation_code: data.confirmation_code || "",
        guest_first_name: data.guest_first_name || "",
        guest_last_name: data.guest_last_name || "",
        guest_email: data.guest_email || "",
        amount:
          data.amount !== undefined && data.amount !== null ? data.amount : "",
        status: data.status || "active",
        custom_message: defaultBody,
        custom_email_subject: defaultSubject,
        expiry_date: expiryDate,
        default_email_subject: defaultSubject,
        default_email_body: defaultBody,
        created_at: data.created_at || "",
        used_at: data.used_at || "",
        last_email_sent_at: data.last_email_sent_at || "",
        is_promo_code: data.is_promo_code ? true : false,
        max_usage_count: data.max_usage_count !== undefined && data.max_usage_count !== null ? data.max_usage_count : "",
        used_count: data.used_count !== undefined && data.used_count !== null ? data.used_count : 0,
      });
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data?.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data?.message ? res.data.message : "Error!",
      });
    }
    this.setState({ loading: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time,
    );
  }

  async getVoucherTemplates() {
    const res = await EmailService.getEmailTemplateList(
      "tab=active&voucher_email_only=1",
    );
    if (global.successStatus.includes(res.status)) {
      const list = res.data ? res.data.data || [] : [];
      const options = list.map((item) => ({
        value: item.slug,
        label: item.template_name,
        subject: item.subject || "",
        body: item.body || "",
      }));
      this.setState({ templateOptions: options });
    }
  }

  changeHandler = (event) => {
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState({ [event.target.name]: value });
  };

  uploadImageButton = () => {
    Jodit.defaultOptions.controls.uploadImage = {
      name: "Upload image",
      exec: async (editor) => {
        await this.imageUpload(editor);
      },
    };
  };

  imageUpload = (editor) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async function () {
      const imageFile = input.files[0];

      if (!imageFile) {
        return;
      }

      if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
        return;
      }
      let fileData = new FormData();

      fileData.append("file", imageFile, imageFile.name);
      fileData.append("fileName", imageFile.name);
      fileData.append("folderName", "jodit");
      const response = await FileUploadService.uploadFromEditor(fileData);
      if (global.successStatus.includes(response.status)) {
        this.insertImage(editor, response.data.filePath);
      }
    }.bind(this);
  };

  insertImage = (editor, url) => {
    const image = editor.selection.j.createInside.element("img");
    image.setAttribute("src", url);
    editor.selection.insertNode(image);
  };

  uploadVideoButton = () => {
    Jodit.defaultOptions.controls.uploadImageVideo = {
      name: "Upload video",
      exec: async (editor) => {
        await this.videoUpload(editor);
      },
    };
  };

  videoUpload = (editor) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "video/*");
    input.click();

    input.onchange = async function () {
      const videoFile = input.files[0];

      if (!videoFile) {
        return;
      }

      if (!videoFile.name.match(/\.(mp3|mp4|mov)$/)) {
        return;
      }
      let fileData = new FormData();

      fileData.append("file", videoFile, videoFile.name);
      fileData.append("fileName", videoFile.name);
      fileData.append("folderName", "jodit");
      const response = await FileUploadService.uploadFromEditor(fileData);
      if (global.successStatus.includes(response.status)) {
        this.insertVideo(editor, response.data.filePath);
      }
    }.bind(this);
  };

  insertVideo = (editor, url) => {
    const video = editor.selection.j.createInside.element("video");
    video.setAttribute("src", url);
    editor.selection.insertNode(video);
  };

  setCustomMessage(value) {
    this.setState({
      custom_message: value,
    });
  }

  handleTemplateSelect(value) {
    if (!value) {
      this.setState({ selectedTemplate: null });
      return;
    }
    const guestName =
      `${this.state.guest_first_name || ""} ${this.state.guest_last_name || ""}`.trim();
    const previewSubject = this.applyPlaceholders(value.subject || "", {
      guest_name: guestName || "Guest",
      voucher_code: this.state.voucher_code || "",
      amount:
        this.state.amount !== undefined && this.state.amount !== null
          ? this.state.amount
          : "",
      status: this.state.status || "",
      expiry_date: this.state.expiry_date || "",
      instructions:
        "Apply this voucher code at checkout to receive your discount. One-time use only.",
    });
    const previewBody = this.applyPlaceholders(value.body || "", {
      guest_name: guestName || "Guest",
      voucher_code: this.state.voucher_code || "",
      amount:
        this.state.amount !== undefined && this.state.amount !== null
          ? this.state.amount
          : "",
      status: this.state.status || "",
      expiry_date: this.state.expiry_date || "",
      instructions:
        "Apply this voucher code at checkout to receive your discount. One-time use only.",
    });
    const normalizedBody = this.normalizeTemplateBodyForEditor(previewBody);
    this.setState({
      selectedTemplate: value,
      custom_email_subject: previewSubject,
      custom_message: normalizedBody,
    });
  }

  resetToDefault() {
    this.setState({
      selectedTemplate: null,
      custom_email_subject: this.state.default_email_subject,
      custom_message: this.state.default_email_body,
    });
  }

  buildDefaultEmailSubject(base, guestName, voucherCode) {
    // const name = guestName && guestName.trim() ? guestName.trim() : "Guest";
    // const code =
    //   voucherCode && voucherCode.trim() ? voucherCode.trim() : "Voucher";
    // return `${base} - ${name} (${code})`;
    return "Thank you for your 5 Start Review";
  }

  buildDefaultEmailBody({
    guest_name,
    voucher_code,
    amount,
    status,
    expiry_date,
    instructions,
  }) {
    const guestName =
      guest_name && guest_name.trim() ? guest_name.trim() : "Guest";
    const voucherCode = voucher_code ? voucher_code : "";
    const amountValue = amount !== undefined && amount !== null ? amount : 0;
    // const statusLine = status
    //   ? `<p><strong>Status:</strong> ${status}</p>`
    //   : "";
    // const expiryLine = expiry_date ? expiry_date : "";
    // const instructionsLine = instructions ? instructions : "";

    return `
<p>Hello ${guestName},</p>
<p>Thank you again for staying with Orion Haus, and we truly appreciate the great review you left us.</p>
<p>As a small thank-you, here is a $${amountValue} voucher you can use toward your next stay with us:</p>
<p>Voucher Code: <strong>${voucherCode}</strong>.</p>
<p>To redeem:</p>
<p>Simply book directly through www.orionhaus.com and apply your voucher code at checkout.</p>
<p>(One-time use only.)</p>
<p>We'd love to host you again soon.</p>
<p>You can also stay connected with us for new locations, travel inspiration, and upcoming stays:</p>
<p>Facebook – https://www.facebook.com/orionhausofficial/</p>
<p>Instagram – https://www.instagram.com/orion.haus/</p>
<p>TikTok – https://www.tiktok.com/@orionhaus</p>
<p>YouTube – https://www.youtube.com/@OrionHaus</p>
<p>Thank you again for your support!</p>
<p>– The Orion Haus Team</p>
`.trim();
  }

  buildPlaceholderMap(values) {
    return {
      guest_name: values.guest_name || "Guest",
      voucher_code: values.voucher_code || "",
      amount:
        values.amount !== undefined && values.amount !== null
          ? values.amount
          : "",
      status: values.status || "",
      expiry_date: values.expiry_date || "",
      instructions: values.instructions || "",
    };
  }

  applyPlaceholders(template, values) {
    if (!template) {
      return "";
    }
    const map = this.buildPlaceholderMap(values);
    let output = template;
    output = output.replace(
      /{{\s*guest_name\s*}}|\[\s*'?guest_name'?\s*\]/gi,
      map.guest_name,
    );
    output = output.replace(
      /{{\s*voucher_code\s*}}|\[\s*'?voucher_code'?\s*\]/gi,
      map.voucher_code,
    );
    output = output.replace(
      /{{\s*amount\s*}}|\[\s*'?amount'?\s*\]/gi,
      map.amount,
    );
    output = output.replace(
      /{{\s*status\s*}}|\[\s*'?status'?\s*\]/gi,
      map.status,
    );
    output = output.replace(
      /{{\s*expiry_date\s*}}|\[\s*'?expiry_date'?\s*\]/gi,
      map.expiry_date,
    );
    output = output.replace(
      /{{\s*instructions\s*}}|\[\s*'?instructions'?\s*\]/gi,
      map.instructions,
    );
    return output;
  }

  normalizePlaceholders(value) {
    if (!value) {
      return "";
    }
    let output = value;
    output = output.replace(/\{\{\s*guest_name\s*\}\}/gi, "[guest_name]");
    output = output.replace(/\{\{\s*voucher_code\s*\}\}/gi, "[voucher_code]");
    output = output.replace(/\{\{\s*amount\s*\}\}/gi, "[amount]");
    output = output.replace(/\{\{\s*status\s*\}\}/gi, "[status]");
    output = output.replace(/\{\{\s*expiry_date\s*\}\}/gi, "[expiry_date]");
    output = output.replace(/\{\{\s*instructions\s*\}\}/gi, "[instructions]");
    output = output.replace(/\[\s*'?guest_name'?\s*\]/gi, "[guest_name]");
    output = output.replace(/\[\s*'?voucher_code'?\s*\]/gi, "[voucher_code]");
    output = output.replace(/\[\s*'?amount'?\s*\]/gi, "[amount]");
    output = output.replace(/\[\s*'?status'?\s*\]/gi, "[status]");
    output = output.replace(/\[\s*'?expiry_date'?\s*\]/gi, "[expiry_date]");
    output = output.replace(/\[\s*'?instructions'?\s*\]/gi, "[instructions]");
    return output;
  }

  normalizeTemplateBodyForEditor(html) {
    if (!html) {
      return "";
    }
    return html.replace(
      /<p([^>]*?)style=(["'])([^"']*)\2([^>]*)>/gi,
      (match, pre, quote, style, post) => {
        const cleaned = style
          .replace(/margin\s*:\s*0\s*;?/gi, "")
          .replace(/margin-top\s*:\s*0\s*;?/gi, "")
          .replace(/margin-bottom\s*:\s*0\s*;?/gi, "")
          .replace(/;;+/g, ";")
          .trim();
        if (!cleaned) {
          return `<p${pre}${post}>`;
        }
        return `<p${pre}style="${cleaned}"${post}>`;
      },
    );
  }

  toPlaceholderSubject(subject, values) {
    if (!subject) {
      return "";
    }
    const map = this.buildPlaceholderMap(values);
    let output = subject;
    if (map.guest_name) {
      output = output.split(map.guest_name).join("{{guest_name}}");
    }
    if (map.voucher_code) {
      output = output.split(map.voucher_code).join("{{voucher_code}}");
    }
    if (map.amount !== "") {
      output = output.split(String(map.amount)).join("{{amount}}");
    }
    if (map.status) {
      output = output.split(map.status).join("{{status}}");
    }
    if (map.expiry_date) {
      output = output.split(map.expiry_date).join("{{expiry_date}}");
    }
    if (map.instructions) {
      output = output.split(map.instructions).join("{{instructions}}");
    }
    return this.normalizePlaceholders(output);
  }

  toPlaceholderBody(body, values) {
    if (!body) {
      return "";
    }
    const map = this.buildPlaceholderMap(values);
    let output = body;
    if (map.guest_name) {
      output = output.split(map.guest_name).join("{{guest_name}}");
    }
    if (map.voucher_code) {
      output = output.split(map.voucher_code).join("{{voucher_code}}");
    }
    if (map.amount !== "") {
      output = output.split(String(map.amount)).join("{{amount}}");
    }
    if (map.status) {
      output = output.split(map.status).join("{{status}}");
    }
    if (map.expiry_date) {
      output = output.split(map.expiry_date).join("{{expiry_date}}");
    }
    if (map.instructions) {
      output = output.split(map.instructions).join("{{instructions}}");
    }
    return this.normalizePlaceholders(output);
  }

  async updateVoucher() {
    if (!this.state.amount) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Amount is required.",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time,
      );
      return;
    }

    // For promo codes, validate that max_usage_count is a positive integer.
    if (this.state.is_promo_code) {
      const maxCount = parseInt(this.state.max_usage_count, 10);
      if (!this.state.max_usage_count || isNaN(maxCount) || maxCount < 1) {
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Validation Error",
          alertModalMessage: "Max Usage Count is required and must be at least 1.",
        });
        setTimeout(
          () => this.setState({ showAlertModal: false }),
          global.alert_close_time,
        );
        return;
      }
    }

    this.setState({ isSubmit: true });
    const payload = {
      amount: parseFloat(this.state.amount),
      status: this.state.status,
      expiry_date: this.state.expiry_date ? this.state.expiry_date : null,
      custom_message: this.state.custom_message
        ? this.state.custom_message
        : null,
    };

    if (this.state.is_promo_code) {
      payload.max_usage_count = parseInt(this.state.max_usage_count, 10);
    }

    const res = await VoucherService.updateVoucher(
      this.state.voucher_code_param,
      payload,
    );
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Updated",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time,
      );
      await this.getVoucherDetail();
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data?.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data?.message ? res.data.message : "Error!",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time,
      );
    }
    this.setState({ isSubmit: false });
  }

  async handleSendEmail() {
    if (!this.state.custom_email_subject) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Subject is required.",
      });
      return;
    }

    const rawBody = (this.state.custom_message || "")
      .replace(/(<([^>]+)>)/gi, "")
      .replace(/&nbsp;/g, "")
      .trim();
    if (!rawBody) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Message is required.",
      });
      return;
    }
    await this.confirmSendEmail();
  }

  openVariableModal(target) {
    this.setState({
      showVariableModal: true,
      variableTarget: target,
      selectedVariable: "",
    });
  }

  closeVariableModal() {
    this.setState({ showVariableModal: false, selectedVariable: "" });
  }

  insertVariable() {
    const variable = this.state.selectedVariable;
    if (!variable) {
      return;
    }
    const token = `[${variable}]`;
    if (this.state.variableTarget === "subject") {
      const subject = this.state.custom_email_subject || "";
      const input = this.subjectInputRef.current;
      if (input && typeof input.selectionStart === "number") {
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const next =
          subject.substring(0, start) + token + subject.substring(end);
        this.setState(
          { custom_email_subject: next, showVariableModal: false },
          () => {
            input.focus();
            const cursor = start + token.length;
            input.setSelectionRange(cursor, cursor);
          },
        );
      } else {
        const next = subject ? `${subject} ${token}` : token;
        this.setState({ custom_email_subject: next, showVariableModal: false });
      }
      return;
    }

    if (this.jodit && this.jodit.selection) {
      if (this.jodit.focus) {
        this.jodit.focus();
      }
      this.jodit.selection.insertHTML(token);
      this.setState({
        custom_message: this.jodit.value || this.state.custom_message,
        showVariableModal: false,
      });
      return;
    }

    const body = this.state.custom_message || "";
    this.setState({
      custom_message: body ? `${body} ${token}` : token,
      showVariableModal: false,
    });
  }

  async confirmSendEmail() {
    this.setState({ isSendSubmit: true });
    const payload = {
      subject: this.state.custom_email_subject,
      body: this.state.custom_message,
    };
    const res = await VoucherService.sendVoucherEmail(
      this.state.voucher_code_param,
      payload,
    );
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Email sent.",
      });
      await this.getVoucherDetail();
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data?.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data?.message ? res.data.message : "Error!",
      });
    }
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time || 3000,
    );
    this.setState({ isSendSubmit: false });
  }

  async saveTemplate() {
    if (!this.state.custom_email_subject) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Subject is required to save template.",
      });
      return;
    }

    const guestName =
      `${this.state.guest_first_name || ""} ${this.state.guest_last_name || ""}`.trim();
    const placeholderValues = {
      guest_name: guestName || "Guest",
      voucher_code: this.state.voucher_code || "",
      amount:
        this.state.amount !== undefined && this.state.amount !== null
          ? this.state.amount
          : "",
      status: this.state.status || "",
      expiry_date: this.state.expiry_date || "",
      instructions:
        "Apply this voucher code at checkout to receive your discount. One-time use only.",
    };
    const placeholderSubject = this.toPlaceholderSubject(
      this.state.custom_email_subject,
      placeholderValues,
    );
    const placeholderBody = this.toPlaceholderBody(
      this.state.custom_message,
      placeholderValues,
    );
    const payload = {
      template_name:
        `Voucher - ${placeholderSubject || this.state.custom_email_subject}`.trim(),
      description: "Voucher email template",
      subject: placeholderSubject || this.state.custom_email_subject,
      body: placeholderBody || this.state.custom_message,
      from: "noreply@orionhaus.com",
      to: 5,
      status_id: 1,
      is_voucher_email_template: 1,
    };
    this.setState({ isTemplateSaving: true });
    const res = await EmailService.createEmailTemplate(payload);
    if (global.successStatus.includes(res.status)) {
      await this.getVoucherTemplates();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Template saved.",
      });
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data?.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data?.message ? res.data.message : "Error!",
      });
    }
    this.setState({ isTemplateSaving: false });
  }

  render() {
    const lastEmailSentAt = this.state.last_email_sent_at
      ? Moment(this.state.last_email_sent_at).format("MM/DD/YY hh:mm A")
      : "";
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    const statusOptions = [
      { value: "active", label: "Active" },
      { value: "used", label: "Used" },
      { value: "expired", label: "Expired" },
    ];
    const selectedStatus =
      statusOptions.find((item) => item.value === this.state.status) ||
      statusOptions[0];
    return (
      <main>
        <Container className="innter-container">
          <div className="d-flex flex-column">
            <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
              <div className="col-md-12">
                <div className="col-md-12 mg-t-20 mg-b-10"></div>
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                  <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                    <h3>Voucher Detail</h3>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn-success-outline-small"
                        onClick={() => this.props.history.push("/vouchers")}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn-success ml-3"
                        onClick={this.updateVoucher}
                        disabled={this.state.isSubmit}
                      >
                        {this.state.isSubmit ? global.loader : "Save"}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="scrolling-carousel pd-l-15 pd-r-15">
                  <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                    <div className="col-md-12 pd-l-30 pd-r-30">
                      <Alerts
                        show={this.state.showAlertModal}
                        type={this.state.alertModalType}
                        title={this.state.alertModalTitle}
                        message={this.state.alertModalMessage}
                      />
                    </div>

                    <div className="row mg-b-20">
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Voucher Code</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={this.state.voucher_code}
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Confirmation Code</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={this.state.confirmation_code}
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Guest Name</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={`${this.state.guest_first_name || ""} ${this.state.guest_last_name || ""}`.trim()}
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Guest Email</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={this.state.guest_email}
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Amount</label>
                          <div className="col-md-12 p-0">
                            <div className="input-group-prepend prefix-dollar">
                              <span className="input-group-text">$</span>
                              <Form.Control
                                type="text"
                                name="amount"
                                step="0.01"
                                min="0"
                                value={this.state.amount}
                                onChange={this.changeHandler}
                              />
                            </div>
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Status</label>
                          <div className="col-md-12 p-0">
                            <Select
                              styles={customStyles}
                              isClearable={false}
                              className="multiselect"
                              menuPlacement="auto"
                              value={selectedStatus}
                              options={statusOptions}
                              onChange={(value) =>
                                this.setState({
                                  status: value ? value.value : "active",
                                })
                              }
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 2,
                                colors: {
                                  ...theme.colors,
                                  primary: "#fff",
                                  primary75: "#000",
                                  primary50: "#000",
                                  primary25: "#000",
                                },
                              })}
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Expiry Date</label>
                          <div className="col-md-12 p-0">
                            <DatePicker
                              className="form-control max_width_100"
                              disabledKeyboardNavigation
                              strictParsing
                              scrollableYearDropdown
                              showMonthDropdown
                              showYearDropdown
                              autoComplete="off"
                              yearDropdownItemNumber={
                                global.yearDropdownItemNumber
                              }
                              dateFormat="MM/dd/yy"
                              selected={
                                this.state.expiry_date
                                  ? Moment(
                                      this.state.expiry_date,
                                      "YYYY-MM-DD",
                                    ).toDate()
                                  : null
                              }
                              onChange={(date) =>
                                this.setState({
                                  expiry_date: date
                                    ? Moment(date).format("YYYY-MM-DD")
                                    : "",
                                })
                              }
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Created At</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={
                                this.state.created_at
                                  ? Moment(this.state.created_at).format(
                                      global.dateFormat,
                                    )
                                  : ""
                              }
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Used At</label>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              type="text"
                              value={
                                this.state.used_at
                                  ? Moment(this.state.used_at).format(
                                      global.dateFormat,
                                    )
                                  : ""
                              }
                              disabled
                            />
                          </div>
                        </InputGroup>
                      </div>
                      <div className="col-md-4">
                        <InputGroup className="mt-3">
                          <label>Type</label>
                          <div className="col-md-12 p-0 d-flex align-items-center" style={{ height: "38px" }}>
                            {this.state.is_promo_code ? (
                              <span className="badge badge-info" style={{ fontSize: "13px", padding: "5px 10px" }}>Promo Code</span>
                            ) : (
                              <span className="badge badge-secondary" style={{ fontSize: "13px", padding: "5px 10px" }}>Voucher</span>
                            )}
                          </div>
                        </InputGroup>
                      </div>
                      {this.state.is_promo_code && (
                        <div className="col-md-4">
                          <InputGroup className="mt-3">
                            <label>Max Usage Count <span style={{ color: "red" }}>*</span></label>
                            <div className="col-md-12 p-0">
                              <Form.Control
                                type="number"
                                name="max_usage_count"
                                min="1"
                                step="1"
                                value={this.state.max_usage_count}
                                onChange={this.changeHandler}
                              />
                            </div>
                          </InputGroup>
                        </div>
                      )}
                      {this.state.is_promo_code && (
                        <div className="col-md-4">
                          <InputGroup className="mt-3">
                            <label>Used Count</label>
                            <div className="col-md-12 p-0">
                              <Form.Control
                                type="text"
                                value={this.state.used_count}
                                disabled
                              />
                            </div>
                          </InputGroup>
                        </div>
                      )}
                    </div>

                    <div className="col-md-12 p-0">
                      <div className="background-head pd-b-15 d-flex justify-content-between align-items-center flex-wrap mg-b-30 mg-t-30">
                        <h3 className="m-0">Send Email to Guest</h3>
                        <div className="d-flex align-items-center">
                          {this.state.guest_email ? (
                            lastEmailSentAt ? (
                              <OverlayTrigger
                                placement="top"
                                trigger="hover"
                                overlay={
                                  <Popover>
                                    <span className="completeBookigHover">
                                      Mail sent at {lastEmailSentAt}
                                    </span>
                                  </Popover>
                                }
                              >
                                <button
                                  type="button"
                                  className="btn-success-outline-small"
                                  onClick={() => this.handleSendEmail()}
                                  disabled={this.state.isSendSubmit}
                                >
                                  {this.state.isSendSubmit
                                    ? global.loader
                                    : "Send"}
                                </button>
                              </OverlayTrigger>
                            ) : (
                              <button
                                type="button"
                                className="btn-success-outline-small"
                                onClick={() => this.handleSendEmail()}
                                disabled={this.state.isSendSubmit}
                              >
                                {this.state.isSendSubmit
                                  ? global.loader
                                  : "Send"}
                              </button>
                            )
                          ) : null}
                          <button
                            type="button"
                            className="btn-success-outline-small ml-2 reset-btn"
                            onClick={this.resetToDefault}
                          >
                            Reset to Default
                          </button>
                          <button
                            type="button"
                            className="btn-success-outline-small ml-2 save-tmp-btn"
                            onClick={this.saveTemplate}
                            disabled={this.state.isTemplateSaving}
                          >
                            {this.state.isTemplateSaving
                              ? global.loader
                              : "Save Template"}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row mg-b-20">
                      <div className="col-md-12">
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mg-t-5 mg-md-t-0  mg-b-15 p-0">
                          <label>Saved Templates</label>
                          <div className="col-md-12 p-0">
                            <Select
                              styles={customStyles}
                              isClearable={true}
                              className="multiselect"
                              menuPlacement="auto"
                              value={this.state.selectedTemplate}
                              options={this.state.templateOptions}
                              onChange={(value) =>
                                this.handleTemplateSelect(value)
                              }
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 2,
                                colors: {
                                  ...theme.colors,
                                  primary: "#fff",
                                  primary75: "#000",
                                  primary50: "#000",
                                  primary25: "#000",
                                },
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mg-t-5 mg-md-t-0  mg-b-15 p-0">
                          <div className="d-flex flex-wrap- justify-content-between align-items-center">
                            <label className="form-label text-left pd-b-5">
                              Subject
                            </label>
                            <button
                              type="button"
                              className="btn btn_var_temp mg-b-5"
                              onClick={() => this.openVariableModal("subject")}
                            >
                              Subject Variable
                            </button>
                          </div>
                          <div className="col-md-12 p-0">
                            <Form.Control
                              ref={this.subjectInputRef}
                              type="text"
                              name="custom_email_subject"
                              value={this.state.custom_email_subject}
                              onChange={this.changeHandler}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-8 col-xxl-8 mg-t-5 mg-md-t-0  mg-b-15 p-0">
                          <div className="d-flex flex-wrap- justify-content-between align-items-center">
                            <label className="form-label text-left pd-b-5">
                              Message
                            </label>
                            <button
                              type="button"
                              className="btn btn_var_temp mg-b-5"
                              onClick={() => this.openVariableModal("body")}
                            >
                              Body Variable
                            </button>
                          </div>
                          <div className="col-md-12 p-0">
                            <JoditEditor
                              config={this.editorConfig}
                              ref={null}
                              name="custom_message"
                              id="custom_message"
                              value={this.state.custom_message}
                              onBlur={(newContent) =>
                                this.setCustomMessage(newContent)
                              }
                              onChange={(newContent) =>
                                this.setCustomMessage(newContent)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <Modal
          show={this.state.showVariableModal}
          onHide={this.closeVariableModal}
          centered
          size="lg"
          className="showquickreplyModal model-temp_var"
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={this.closeVariableModal}>
              {global.closee}
            </span>
            <h3 className="text-center">Insert Variable</h3>
            <div className="row col-12 m-0">
              <div className="var_tmp_modal mg-t-10">
                <div className="var_tmp_box">
                  <h4 className="text-left var_pop_head">Guest</h4>
                  <ul>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "guest_name" })
                        }
                        name="voucher_variable"
                        value="guest_name"
                        type={"radio"}
                        id="voucher-variable-guest-name"
                        label={"guest_name"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                  </ul>
                </div>
                <div className="var_tmp_box">
                  <h4 className="text-left var_pop_head">Voucher</h4>
                  <ul>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "voucher_code" })
                        }
                        name="voucher_variable"
                        value="voucher_code"
                        type={"radio"}
                        id="voucher-variable-voucher-code"
                        label={"voucher_code"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "amount" })
                        }
                        name="voucher_variable"
                        value="amount"
                        type={"radio"}
                        id="voucher-variable-amount"
                        label={"amount"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "status" })
                        }
                        name="voucher_variable"
                        value="status"
                        type={"radio"}
                        id="voucher-variable-status"
                        label={"status"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "expiry_date" })
                        }
                        name="voucher_variable"
                        value="expiry_date"
                        type={"radio"}
                        id="voucher-variable-expiry-date"
                        label={"expiry_date"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                    <li>
                      <Form.Check
                        onChange={() =>
                          this.setState({ selectedVariable: "instructions" })
                        }
                        name="voucher_variable"
                        value="instructions"
                        type={"radio"}
                        id="voucher-variable-instructions"
                        label={"instructions"}
                        className={"rdiobox mg-r-20"}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <br></br>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className=" m-0 btn btn-outline-light btn-block"
                onClick={this.closeVariableModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.insertVariable}
                disabled={!this.state.selectedVariable}
              >
                Insert
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    );
  }
}

export default VoucherDetail;
